import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '@xingternal/tokens';
import { Helmet } from 'react-helmet-async';
import { useXingHub } from '@xingternal/xing-hub';
import { useFrameContext } from '@xingternal/hub';
import { selectCookieDataByName } from './cookie-parsing';
const getClientCookieData = () => {
    try {
        const rm = selectCookieDataByName(document.cookie, 'rm');
        if (!rm) {
            return null;
        }
        return JSON.parse(rm);
    }
    catch (e) {
        return null;
    }
};
const useHubState = () => {
    const cookies = useXingHub().cookies;
    // priority order is
    // 1. client cookies if present
    // 2. hops cookies otherwise
    // 3. default to system if no cookies present
    const clientCookie = getClientCookieData();
    const rmCookie = clientCookie ||
        JSON.parse((cookies && cookies.rm) || '{ "activeTheme": "system" }');
    const { moduleState } = useFrameContext();
    const [hubState, setHubState] = moduleState;
    const theme = hubState.activeTheme || rmCookie.activeTheme;
    return { theme, hubState, setHubState, rmCookie };
};
const ThemingProvider = ({ children }) => {
    const { theme } = useHubState();
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, null),
        React.createElement(Helmet, null,
            React.createElement("html", { className: theme })),
        React.createElement(ThemeProvider, { theme: { mode: theme } }, children)));
};
const enhanceElement = (_, children) => {
    return React.createElement(ThemingProvider, null, children);
};
const getHooks = () => {
    const useTheme = () => {
        const { theme, hubState, setHubState, rmCookie } = useHubState();
        const setTheme = (activeTheme) => {
            document.cookie = `rm=${JSON.stringify({
                ...rmCookie,
                activeTheme,
            })};path=/`;
            setHubState({ ...hubState, activeTheme });
        };
        return [theme, setTheme];
    };
    return { useTheme };
};
export const themingModule = {
    name: 'themingModule',
    getHooks,
    enhanceElement,
};
//# sourceMappingURL=theming.js.map